// extracted by mini-css-extract-plugin
export default {"grouped-select-filters":"ManageServices_grouped-select-filters__bpZ6b"};